import { PDFViewer } from '@react-pdf/renderer';
import React from 'react';
import { Modal } from 'react-bootstrap';
import CetakLampTeknisCPPIB from '../../../cetak/primer/CetakLampTeknisCPPIB';
import CetakLampTeknisCBIB from '../../../cetak/primer/CetakLampTeknisCBIB';
import CetakLampTeknisCPIB from '../../../cetak/primer/CetakLampTeknisCPIB';
import CetakLampTeknisCPOIB from '../../../cetak/primer/CetakLampTeknisCPOIB';
import CetakLampTeknisCDOIB from '../../../cetak/primer/CetakLampTeknisCDOIB';

const ModalCetakLamp = ({ showCetakLamp, handleCloseCetakLamp, rowData, laporanFile, lampiranTeknis, dataOssHeader, dataProyek, dataProyekLokasi }) => {
    return (
        <>
            <Modal
                show={showCetakLamp}
                onHide={handleCloseCetakLamp}
                keyboard={false}
                scrollable={true}
                size='xl'
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 800 }}>
                        {
                            rowData !== null && rowData.urIzinSingkat === 'CPPIB' &&
                            <CetakLampTeknisCPPIB rowData={rowData} laporanFile={laporanFile} lampiranTeknis={lampiranTeknis} dataOssHeader={dataOssHeader} dataProyek={dataProyek} dataProyekLokasi={dataProyekLokasi}/>
                        }
                        {
                            rowData !== null && rowData.urIzinSingkat === 'CBIB' &&
                            <CetakLampTeknisCBIB rowData={rowData} laporanFile={laporanFile} lampiranTeknis={lampiranTeknis} dataProyekLokasi={dataProyekLokasi} />
                        }
                        {
                            rowData !== null && rowData.urIzinSingkat === 'CPIB' &&
                            <CetakLampTeknisCPIB rowData={rowData} laporanFile={laporanFile} lampiranTeknis={lampiranTeknis} dataProyekLokasi={dataProyekLokasi} />
                        }
                        {
                            rowData !== null && rowData.urIzinSingkat === 'CPOIB' &&
                            <CetakLampTeknisCPOIB rowData={rowData} lampiranTeknis={lampiranTeknis} />
                        }
                        {
                            rowData !== null && rowData.urIzinSingkat === 'CDOIB' &&
                            <CetakLampTeknisCDOIB rowData={rowData} lampiranTeknis={lampiranTeknis} />
                        }
                    </PDFViewer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCetakLamp